var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.show
    ? _c(
        _setup.FormSidebarBtn,
        {
          attrs: { disabled: _setup.order.gatewayId === 0 },
          nativeOn: {
            click: function ($event) {
              $event.preventDefault()
              return _setup.printInvoice.apply(null, arguments)
            },
          },
        },
        [
          _c("i", { staticClass: "me-2 bi-printer" }),
          _vm._v("\n    " + _vm._s(_setup.text) + "\n"),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }